module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAb1BMVEUAAABicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZmHwNhaAAAAJHRSTlMABuuOhZUSZUYx9PDa1bexJefPw6SdenNaUEErGg3m4MpAPh5zkjuSAAAAqUlEQVQoz4WQ2Q6EIAxFawEV9313Vv7/GwdFQyyZeB5Iw0nT28INX97wAlymSGkCoHhPteP0hMrQUREcglEhD+EOyYxofSrWXH9XkmHvUYWD1O+cpSFcnEzOgEmq0sWKXtjol3TZeFaDFtyuHq2m8Bk2j9yGm2rjg1JcE/O9+V3VMwn7+gAUeTKS2zJUwufY0eW40kTtApRyEzG44D/BNmE2p8NjFHbwHT+CTg4KwDp1pQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_thirdparty.png
// module id = y240
// module chunks = 9